import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const proofOfGoodStudent: TaskDefinition = {
  taskName: onboardingTasks.ProvideProofOfGoodStudent,
  config: {
    staffDisplayName: 'Proof of good student',
    appcuesModalId: '3e9f15c2-1e9d-46d7-a0cd-bbbbfb300a0b',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of Good Student',
    account: {
      toastMessage: 'Your proof of good student documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed, data, brandName }) => {
        const customerSuffix = data.customer ? ` for ${data.customer}` : '';
        return {
          title: `Proof of good student${customerSuffix}`,
          incompleteSubtitle: "Provide your student's grades to keep your Good Student discount.",
          completedSubtitle: `You have successfully submitted for review the academic documents for ${affectedPolicies}.`,
          actionLabel: 'Upload proof',
          modalTitle: `Upload your proof of good student${customerSuffix}`,
          contentSections: [
            {
              title: 'Who is eligible?',
              body: 'The good student discount is available to be applied to any driver under the age of 23 who is not the primary named insured or spouse. They must be a full-time student and in good academic standing in order to apply.'
            },
            {
              title: 'What documents are accepted?',
              subtitle: 'You can provide one of the following documents:',
              body: [
                'A report card showing any of the following: a rank in the upper 20th percentile, an overall grade average of at least a B, or a GPA of at least 3.0',
                "Scholastic achievements of: Dean's List, honor roll, or comparable listing",
                'Test results in the 20th percentile in any of the following standardized tests: PSAT, PACT, SAT, ACT, IA test, CA achievement, or TAP.3'
              ],
              isList: true
            },
            {
              title: null,
              subtitle: 'To be considered, the verification documents should also:',
              body: [
                `Be dated within 12 months of the effective date of your ${brandName} policy`,
                `Show the student is also insured on the ${brandName} policy`
              ],
              isList: true
            },
            {
              title: 'What if my student is home-schooled?',
              body: 'An equivalent to any of these items counts as good academic standing.'
            },
            {
              title: 'When do I need to submit these documents?',
              body: `You have ${daysAllowed} days from your policy effective date to turn in verification listed above before the discount is removed.`
            }
          ]
        };
      }
    }
  }
};
